<div class="claim-container">
    <div class="claim-card mat-elevation-z8">
        <div class="claim-header">
            <img src="./assets/accept.png" onerror="this.src='https://aieventzo.com/upload/default.png'" alt="AiEventZo"
                class="app-logo">
            <h2 class="claim-title">QR Rewards</h2>
        </div>

        <!-- Loading State -->
        <div *ngIf="loading" class="spinner-container">
            <mat-spinner diameter="50" color="primary"></mat-spinner>
            <p class="loading-text">Processing your claim, please wait...</p>
        </div>

        <!-- Result States -->
        <div *ngIf="!loading" class="result-container">
            <!-- Success State -->
            <div *ngIf="result?.flag" class="success-state animated scale-in">
                <div class="icon-badge success">
                    <mat-icon>check_circle</mat-icon>
                </div>
                <h3 class="success-title">Points Claimed!</h3>
                <p class="success-message">{{result?.msg}}</p>

                <div class="reward-badge">
                    <div class="points-circle">
                        <span class="points-num">{{result?.points}}</span>
                        <span class="points-lbl">Points</span>
                    </div>
                </div>

                <div class="claim-details">
                    <div class="detail-row">
                        <span class="lbl">Product</span>
                        <span class="val">{{result?.product_title}}</span>
                    </div>
                    <div class="detail-row">
                        <span class="lbl">Stall</span>
                        <span class="val">{{result?.company_name}}</span>
                    </div>
                </div>

                <button mat-raised-button color="primary" class="action-btn" routerLink="/admin/Dashboard">
                    Go to Dashboard
                </button>
            </div>

            <!-- Failure/Error State -->
            <div *ngIf="!result?.flag" class="failure-state animated scale-in">
                <div class="icon-badge error">
                    <mat-icon>cancel</mat-icon>
                </div>
                <h3 class="error-title">Claim Failed</h3>
                <p class="error-message">{{result?.msg || 'Something went wrong while claiming this reward.'}}</p>

                <div class="claim-details error-details" *ngIf="result?.product_title">
                    <div class="detail-row">
                        <span class="lbl">Product</span>
                        <span class="val">{{result?.product_title}}</span>
                    </div>
                    <div class="detail-row">
                        <span class="lbl">Stall</span>
                        <span class="val">{{result?.company_name}}</span>
                    </div>
                </div>

                <button mat-raised-button color="primary" class="action-btn" routerLink="/admin/Dashboard">
                    Go to Dashboard
                </button>
            </div>
        </div>
    </div>
</div>
